import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let DxUser = class DxUser {
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get login() {
        return this._login;
    }
    set login(value) {
        this._login = value;
    }
    get firstName() {
        return this._firstName;
    }
    set firstName(value) {
        this._firstName = value;
    }
    get lastName() {
        return this._lastName;
    }
    set lastName(value) {
        this._lastName = value;
    }
    get fullName() {
        return this._firstName + this._lastName;
    }
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], DxUser.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "login", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUser.prototype, "_login", void 0);
tslib_1.__decorate([
    jsonMember({ name: "firstName", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUser.prototype, "_firstName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "lastName", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUser.prototype, "_lastName", void 0);
tslib_1.__decorate([
    jsonMember({ name: "position", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], DxUser.prototype, "_position", void 0);
DxUser = tslib_1.__decorate([
    jsonObject
], DxUser);
export { DxUser };
